module.exports = __webpack_public_path__ + "static/media/icon-camera.cdda16fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-camera.svg
// module id = 985
// module chunks = 0